import { useState } from "react";
import type { MediaTitle } from "@/types/media";

interface EpisodeListProps {
  item: MediaTitle;
}

export default function EpisodeList({ item }: EpisodeListProps) {
  const total = item.episodes ?? 0;
  const [active, setActive] = useState(1);

  if (total === 0) return null;

  const visibleCount = 30;
  const episodes = Array.from({ length: Math.min(total, visibleCount) }, (_, i) => i + 1);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="flex items-center gap-2 text-base font-bold text-foreground-950 font-heading">
          <i className="ri-play-list-line text-primary-500" />
          剧集列表
        </h2>
        <span className="text-xs text-foreground-500">共 {total} 集</span>
      </div>

      <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-2">
        {episodes.map((ep) => (
          <button
            key={ep}
            type="button"
            onClick={() => setActive(ep)}
            className={`py-2 text-xs rounded-md transition-colors cursor-pointer ${
              ep === active
                ? "bg-primary-500 text-background-50 font-semibold"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            第{ep}集
          </button>
        ))}
      </div>

      <div className="mt-4 rounded-md bg-background-100 border border-background-200 p-4">
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded-md text-[11px] font-semibold bg-accent-500 text-background-50">
            第 {active} 集
          </span>
          <span className="text-xs text-foreground-500">内容简介（演示）</span>
        </div>
        <p className="text-sm text-foreground-700 leading-relaxed">
          {item.title} 第 {active} 集：故事在此继续推进，人物关系与主线悬念进一步展开。这里展示的是本集的内容概要演示文本，用于说明剧集切换交互，页面不提供任何在线播放功能。
        </p>
      </div>
    </div>
  );
}